import {ServiceContent} from "../../../"

export class ServiceContentResponseDTO implements Record<string, ServiceContent> {
    [serviceId: string]: ServiceContent
    constructor(
        sourceObj: { [serviceId: string]: ServiceContent }
    ) {
        Object.entries(sourceObj).forEach(([key, value]) => {
            this[key] = value
        })
    }
}

